<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--自定义查看按钮-->
      <template slot-scope="{ row }" slot="menu">
        <el-button
          type="text"
          icon="el-icon-setting"
          size="small"
          plain
          style="border: 0; background-color: transparent !important"
          @click.stop="handleDataScope(row)"
          >查看
        </el-button>
      </template>
    </avue-crud>

    <!--弹出框-->
    <el-drawer
      :title="`对账异常信息`"
      :visible.sync="drawerVisible"
      :direction="direction"
      :before-close="handleDrawerClose"
      :append-to-body="true"
      size="1580px"
    >
      <basic-container>
        <avue-crud
          :option="optionScope"
          :data="dataScope"
          :page="pageScope"
          v-model="formScope"
          :table-loading="scopeLoading"
          ref="crudScope"
          :before-open="beforeOpenScope"
          @current-change="currentChangeScope"
          @size-change="sizeChangeScope"
          @on-load="onLoadScope"
        >
        </avue-crud>
        <span style="color: red">注意：出现对账异常，请联系系统管理员处理！</span>
      </basic-container>
    </el-drawer>
  </basic-container>
</template>

<script>
import { getPayBillLogDetailsList } from '@/api/v4ward/pay/paybilllogdetails';
import { add, getDetail, getList, remove, update } from '@/api/v4ward/pay/paybilllog';
import { mapGetters } from 'vuex';

export default {
  data() {
    const date = new Date();
    let defaultEndDay = this.dayjs(date).format('YYYY-MM-DD');
    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    let defaultStartDay = this.dayjs(date).format('YYYY-MM-DD');
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,

        column: [
          {
            label: '主键Id',
            prop: 'id',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键Id',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '账号',
            prop: 'account',
            width: 120,
            rules: [
              {
                required: true,
                message: '账号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对账单日期',
            prop: 'billDate',
            width: 100,
            type: 'date',
            searchRange: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            startPlaceholder: defaultStartDay,
            endPlaceholder: defaultEndDay,
            searchLabelWidth: 100,
            searchSpan: 8,
            rules: [
              {
                required: true,
                message: '请输入对账单日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          
          {
            label: '应结笔数(系统)',
            prop: 'settlementNo',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结笔数(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '补单笔数',
            prop: 'autoRepairNo',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结笔数(渠道)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应结笔数(渠道)',
            prop: 'outSettlementNo',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结笔数(渠道)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应结金额(系统)',
            prop: 'settlementFee',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结金额(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '补单金额',
            prop: 'autoRepairFee',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结金额(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应结金额(渠道)',
            prop: 'outSettlementFee',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结金额(渠道)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对账时间',
            prop: 'billTime',
            width: 150,
            rules: [
              {
                required: true,
                message: '请输入对账时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对账状态',
            prop: 'billStatus',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=success_fail',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入对账状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '补单标识',
            prop: 'autoRepairFlag',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=success_fail',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入自动补单标识',
                trigger: 'change',
              },
            ],
          },
          {
            labelWidth: 0,
            label: '',
            prop: 'info',
            span: 24,
            hide: true,
            formslot: true,
          },
        ],
      },
      data: [],

      // 新增表格属性
      drawerVisible: false,
      direction: 'rtl',

      scopePayBillLogId: 0,

      formScope: {},
      queryScope: {},
      scopeLoading: false,
      pageScope: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionListScope: [],

      optionScope: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        menu: false,
        viewBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        emptyText: '暂无对账异常数据！',
        column: [
          {
            label: '对账日志表ID',
            prop: 'payBillLogId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入对账日志表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对账单日期',
            prop: 'billDate',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入对账单日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '接入方式',
            prop: 'payMethod',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payMethod',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入接入方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易类型',
            prop: 'tradeType',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=tradeType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入交易类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商户订单/退款单号(系统)',
            prop: 'mchOrderNo',
            width: 220,
            rules: [
              {
                required: true,
                message: '请输入商户订单/退款单号(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应结订单(系统)',
            prop: 'settlementTradeFee',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结订单/退款金额(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付/退款时间(系统)',
            prop: 'payOrRefundTime',
            width: 180,
            rules: [
              {
                required: true,
                message: '请输入支付成功/退款申请时间(系统)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商户订单/退款单号(渠道)',
            prop: 'mchOrderNoOut',
            width: 240,
            rules: [
              {
                required: true,
                message: '请输入商户订单/退款单号(渠道)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应结订单(渠道)',
            prop: 'settlementTradeFeeOut',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入应结订单/退款金额(渠道)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付/退款时间(渠道)',
            prop: 'payOrRefundTimeOut',
            width: 180,
            rules: [
              {
                required: true,
                message: '请输入支付成功/退款申请时间(渠道)',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      dataScope: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.paybilllog_add, false),
        viewBtn: this.vaildData(this.permission.paybilllog_view, false),
        delBtn: this.vaildData(this.permission.paybilllog_delete, false),
        editBtn: this.vaildData(this.permission.paybilllog_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page);
    },
    onLoad(page) {
      page = page || this.page;

      const { billDate } = this.query;

      let values = {
        ...this.query,
      };

      if (billDate) {
        values = {
          ...this.query,
          startBillDate: billDate[0],
          endBillDate: billDate[1],
        };
        values.billDate = null;
      }

      this.loading = true;

      if (!values.startBillDate) {
        const date = new Date();
        values.endBillDate = this.dayjs(date).format('YYYY-MM-DD');
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        values.startBillDate = this.dayjs(date).format('YYYY-MM-DD');
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },

    //弹出框表格
    handleDataScope(row) {
      this.drawerVisible = true;
      this.scopePayBillLogId = row.id;
      this.onLoadScope(this.pageScope);
    },
    handleDrawerClose(hide) {
      hide();
    },
    beforeOpenScope(done) {
      done();
    },
    currentChangeScope(currentPage) {
      this.pageScope.currentPage = currentPage;
    },
    sizeChangeScope(pageSize) {
      this.pageScope.pageSize = pageSize;
    },
    onLoadScope(page, params = {}) {
      this.scopeLoading = true;

      const values = {
        ...params,
        mainPayBillLogId: this.scopePayBillLogId,
      };
      getPayBillLogDetailsList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, values)
      ).then(({ data }) => {
        this.pageScope.total = data.total;
        this.dataScope = data.records;
        this.selectionListScope = [];
        this.scopeLoading = false;
      });
    },
  },
};
</script>

<style></style>
